import type { ReactNode } from "react";

/**
 * 지금 무언가 돌고 있음을 알리는 표시.
 *
 * OCR 은 몇 초에서 몇십 초가 걸린다. 그동안 `읽는 중` 이라는 글자가 가만히 서 있으면
 * **멈춘 것과 구분되지 않아** 담당자가 새로고침을 누르거나 사진을 다시 올린다
 * (담당자 요청 2026-09-10). 점 세 개가 순서대로 밝아지며 아직 살아 있다고 말한다.
 *
 * **스피너·아이콘은 쓰지 않는다** (CLAUDE.md §UI 1). 가운뎃점의 명도만 순환하므로
 * 색도, 장식도 쓰지 않는다 — 무채색 꼬리표(`Tag`) 안에 넣어도 그대로 읽힌다.
 * 생김새는 `index.css` 의 `.hj-working-dot` 한 곳에서 나온다.
 *
 * 폭이 변하지 않아 표 안에서 줄이 흔들리지 않는다.
 *
 * ```tsx
 * <Working>읽는 중</Working>
 * <Tag tone="strong"><Working>읽는 중 {n}</Working></Tag>
 * ```
 */
export default function Working({ children }: { children?: ReactNode }) {
  return (
    <span className="inline-flex items-baseline whitespace-nowrap">
      {children}
      {/*
        점은 장식이 아니라 진행 표시다. 다만 글자가 이미 `읽는 중` 이라 말하고 있으므로
        읽어 주면 같은 말이 두 번 나간다 — 화면 낭독기에서는 숨긴다.
      */}
      <span aria-hidden className="ml-0.5 inline-flex">
        <span className="hj-working-dot">·</span>
        <span className="hj-working-dot">·</span>
        <span className="hj-working-dot">·</span>
      </span>
    </span>
  );
}
